<template>
  <div class="header">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../assets/images/dongguologo.jpg"
    />
    <div class="navbar navbar-fixed-top">
      <div class="header_top">
        <div class="left">
          <img src="../assets/images/phone.png" alt="" />
          <p>全国统一招生咨询热线：400-800-8772</p>
        </div>
      </div>
      <div class="head_tab">
        <div class="head_tab_top">
          <a href="/">
            <img
              src="../assets/images/logo.png"
              @click="dianji"
              alt="秋溪艺术大学"
            />
          </a>
          <div class="dengGe" v-if="isShou">
            <p class="dengl rz" @click="changeResgin('注册')">注册</p>
            <p class="dengl rz">/</p>
            <p class="dengl rz" @click="changeResgin('登录')">登录</p>
          </div>
          <div class="user" v-if="userShou">
            <img :src="imgSrc" class="touxiang" alt />
            <p class="shouji rz">{{ phonenumber }}</p>
            <a href="javascript:;" @click="logout">退出</a>
          </div>
          <span
            class="dow"
            role="button"
            data-toggle="collapse"
            href="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            <!-- <van-icon name="wap-nav" size="30px" /> -->
            <img src="../assets/images/矩形 2 拷贝 4.png" alt="" />
          </span>
        </div>
        <div class="head-tab-main collapse" id="collapseExample">
          <!-- <div
            class="lableli"
            v-for="(item, index) in menu"
            :key="index"
            @click="NavClickItem(item)"
          >
            <p>
              {{ item.label }}
            </p>
            <img src="../assets/images/nav_icon.png" />
          </div> -->
          <a
            :href="'/' + item.data.Path + '.html'"
            class="lableli"
            v-for="(item, index) in menu"
            :key="index"
            target="_blank"
          >
            <p>
              {{ item.label }}
            </p>
            <img src="../assets/images/nav_icon.png"
          /></a>
          <!-- <van-collapse
            class="collapseExample_collapse"
            v-model="activeName"
            v-for="(item, index) in menu"
            accordion
            :key="item.id"
          >
            <van-collapse-item
              class="collapseExample_item"
              :title="item.label"
              :name="index"
            >
              <van-list
                class="collapseExample_list"
                v-for="items in item.children"
                :key="items.id"
              >
                <div class="xiegan"></div>
                <van-cell
                  class="collapseExample_cell"
                  :title="items.label"
                  @click="getIndex(items)"
                />
              </van-list>
            </van-collapse-item>
          </van-collapse> -->
        </div>
      </div>
    </div>
    <!-- 登录弹框 -->
    <div class="loginRegistration" v-if="dialogVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="loginRegistration_form"
      >
        <div class="prompt">
          <p class="p1">登录账号</p>
        </div>
        <div class="enter">
          <div class="tip">
            <p>新用户登陆后将自动创建账号</p>
          </div>
          <el-form-item prop="tel" class="getTel">
            <el-input
              v-model="ruleForm.tel"
              placeholder="+86 请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" class="getCode">
            <el-input
              v-model="ruleForm.code"
              placeholder="请填写手机验证码"
            ></el-input>
            <el-button
              tabindex="-1"
              @click="getCode"
              :disabled="disabled"
              class="getCode_btn"
              >{{ codeInfo }}</el-button
            >
          </el-form-item>
          <el-form-item class="loginBtnbox">
            <div class="terms">
              <el-checkbox v-model="ruleForm.checked"></el-checkbox>
              <p class="xy">
                我已阅读并同意
                <a href="javascript:;" tabindex="-1" @click="protocol"
                  >《留归用户协议》</a
                >
                <a href="javascript:;" tabindex="-1" @click="protocolEr"
                  >《隐私政策》</a
                >
              </p>
            </div>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="loginBtn"
              v-loading.fullscreen.lock="loading"
              >登录</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <!-- <Foot></Foot> -->
    </div>
    <UserAgreement
      :isbool="isbool"
      @close-dialogStatus="closeDialog"
      @isShow="isShow"
    ></UserAgreement>
    <PrivacyPolicy
      :isbool="isboolEr"
      @close-dialogStatus="closeDialogEr"
      @isShowEr="isShowEr"
    ></PrivacyPolicy>
    <!-- 需要存储cookie的页面 -->
    <iframe
      v-for="(item, index) in pagesArrs"
      :key="index"
      @load="PagesLoading"
      :src="item"
      frameborder="0"
      width="0"
      height="0"
    ></iframe>
  </div>
</template>
<script>
import Bus from "./bus.js";
import UserAgreement from "./UserAgreement.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";
import Foot from "./Foot.vue";
// import { getCookie, setCookie, delCookie } from "@/util/util.js";
import { getCookie, setCookie, delCookie } from "../util/util.js";
import Vue from "vue";
import { Notify } from "vant";
// 引入wxjs-sdk
import wx from "weixin-js-sdk";
export default {
  components: { UserAgreement, PrivacyPolicy, Foot },
  data() {
    return {
      isbool: false,
      isboolEr: false,
      activeName: 0,
      menu: [],
      isShou: true, // 登录注册
      userShou: false, // 用户名
      dialogVisible: false, // 登录弹框
      pagesArrs: [], // 需要存储cookie页面的数组
      title: "", // 登录注册改变
      ruleForm: {
        tel: "",
        code: "",
        checked: false,
      },
      rules: {
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      disabled: false,
      codeInfo: "获取验证码",
      //登录按钮加载中
      loading: false,
      pageNum: 0,
      phoneCookie: this.getCookie("tel"),
      imgSrc: require("../assets/images/denglu_qiehuan.png"),
      phonenumber: "",
      shenqingList: [],
	  currentOS:'其他',
	  currentUrl:'',
    };
  },
  watch: {
    $route: function (val) {
      // 获取appid
      this.getAppid();
	  this.recordWebsiteVisit()
    },
    deep: true,
    immediate: true,
  },
  mounted() {
    this.getList();
    this.shenqingData();
    if (
      sessionStorage.getItem("Phone") ||
      getCookie("tel") ||
      getCookie("Phone") ||
      localStorage.getItem("Phone")
    ) {
      this.isShou = false;
      this.userShou = true;
      this.phonenumber =
        sessionStorage.getItem("Phone") ||
        getCookie("tel") ||
        getCookie("Phone") ||
        localStorage.getItem("Phone");
    }
	this.recordWebsiteVisit()
  },
  methods: {
	//网站统计
	  recordWebsiteVisit(){
		  var BrowserInfo = this.getBrowserInfo()
		  var url=window.location.href
		  if(BrowserInfo.os.indexOf("iphone")>-1)
		  {
		  	this.currentOS='iphone os'
		  }
		  if(BrowserInfo.os.indexOf("android")>-1)
		  {
		  	this.currentOS='android'
		  }
		  if(url.indexOf("?")>-1)
		  {
		  	this.currentUrl=url.split('?')[0]
		  }
		  else
		  {
		  	this.currentUrl=url
		  }
		  setTimeout(() => {
		  	this.$axios
		  	  .post("/trip/tokenpass/WebsiteVisit/RecordWebsiteVisit", {
		  		IP: sessionStorage.getItem("currentIp"),
		  		Position: sessionStorage.getItem("currentCity"),
		  		OperationSystem:this.currentOS,
		  		Browser:BrowserInfo.browser,
		  		Origin: 487,
		  		VisitPage: this.currentUrl,
		  		VisitPageTitle: document.title,
		  	  })
		  	  .then((res) => {
		  		// console.log(res);
		  	  });
		  }, 500)
	  },
	//获取当前浏览器信息
	getBrowserInfo(){
		
		let userAgent = navigator.userAgent,
		  ua = userAgent.toLowerCase(),
		  browserList = {
		    msie: /(?:msie\s|trident.*rv:)([\w.]+)/i,
		    firefox: /Firefox\/([\w.]+)/i,
		    chrome: /Chrome\/([\w.]+)/i,
		    safari:
		      /version\/([\w.]+).*Safari/i,
		    opera:
		      /(?:OPR\/|Opera.+version\/)([\w.]+)/i,
		  },
		  kernels = {
		    MSIE: /(compatible;\smsie\s|Trident\/)[\w.]+/i,
		    Camino: /Camino/i,
		    KHTML: /KHTML/i,
		    Presto: /Presto\/[\w.]+/i,
		    Gecko: /Gecko\/[\w.]+/i,
		    WebKit: /AppleWebKit\/[\w.]+/i,
		  },
		  browser = {
		    kernel: "其他",
		    version: "其他",
		  };
				
		// 检测浏览器
		for (let i in browserList) {
		  const matchs = ua.match(
		    browserList[i]
		  );
		  // browser[i] = matchs ? true : false;
		  if (matchs) {
		    browser.version = matchs[1];
		    browser.browser = i;
		  }
		}
				
		// 检测引擎
		for (let i in kernels) {
		  const matchs = ua.match(kernels[i]);
		  if (matchs) {
		    browser.kernel = matchs[0];
		  }
		}
				
		// 系统
		const os = ua.match(
		  /(Windows\sNT\s|Mac\sOS\sX\s|Android\s|ipad.*\sos\s|iphone\sos\s)([\d._-]+)/i
		);
		browser.os =
		  os !== null ? os[0] : '';
				
		// 是否移动端
		browser.mobile =
		  ua.match(/Mobile/i) !== null
		    ? true
		    : false;
				
		return browser;
	},
    // 获取appid
    getAppid() {
      this.$axios
        .post("/trip/v1/WeChatAPI/GetWeChatAccessToken", {
          url: window.location.href.split("#")[0],
          OapSerialNumber: 2, //微信公众号内部序号 1韩流姐微信公众号(默认) 2菲律宾留学通 3学在白石(未认证) 4韩腾教育
        })
        .then((res) => {
          const _data = res.data.Data;
          wx.config({
            debug: false, // 开启调试模式
            appId: _data.AppId, // 必填，公众号的唯一标识
            timestamp: _data.timestamp, // 必填，生成签名的时间戳
            nonceStr: _data.noncestr, // 必填，生成签名的随机串
            signature: _data.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData", //自定义“分享给朋友”
              "updateTimelineShareData", //自定义“分享朋友圈”
            ],
          });
          //获取当前页面描述
          var meta = document.getElementsByTagName("meta");
          var share_desc = "";
          for (var i in meta) {
            if (meta[i].name == "description") {
              share_desc = meta[i].content;
            }
          }
          // 分享朋友
          const shareData = {
            title: document.title, //分享标题
            desc: share_desc ? share_desc : document.title, //分享描述
            imgUrl: "http://m.dguedu.com/dongguologo.jpg", //分享图标
            //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: window.location.href.split("#")[0],
          };
          // 分享朋友圈
          const lineShareData = {
            title: document.title, //分享标题
            desc: share_desc ? share_desc : document.title, //分享描述
            imgUrl: "http://m.dguedu.com/dongguologo.jpg", //分享图标
            // //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: window.location.href.split("#")[0],
          };
          // 函数执行
          wx.ready(() => {
            // console.log('ready')
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(lineShareData);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isShow() {
      this.isbool = false;
    },
    isShowEr() {
      this.isboolEr = false;
    },
    // iframe页面改变
    PagesLoading() {
      this.pageNum++;
    },
    // 登陆注册改变
    changeResgin(title) {
      this.title = title;
      this.dialogVisible = true;
      Bus.$emit("isLoginFun", false);
    },
    // 点击退出按钮
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      delCookie("Phone");
      delCookie("Data");
      this.isShou = true;
      this.userShou = false;
    },
    // 设置cookie
    setCookie,
    // 获取cookie
    getCookie,
    // 弹框
    handleClose(done) {
      this.dialogVisible = false;
      Bus.$emit("isLoginFun", true);
    },
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.checked) {
            Notify({
              type: "warning",
              message: "请阅读并同意《留归用户协议》《隐私政策》",
            });
            return false;
          }
		  this.dialogVisible = false;
		  Bus.$emit("isLoginFun", true);
		  // 存储手机
		  sessionStorage.setItem(
		    "Phone",
		    this.ruleForm.tel
		  );
		  localStorage.setItem("Phone", this.ruleForm.tel);
		  setCookie("Phone", this.ruleForm.tel, 28800),
		  // 右上角手机号
		  this.phonenumber = this.ruleForm.tel;
		  this.isShou = false;
		  this.userShou = true;
		  return
          this.$axios
            .post("/api/Oauth2/AccessToken", {
              UserCode: this.ruleForm.tel,
              Code: this.ruleForm.code,
            })
            .then((res) => {
              if (res.data.Code == 200) {
                this.$axios
                  .post("/trip/TokenPass/CheckLoginCode", {
                    Phone: this.ruleForm.tel,
                    // Code: this.ruleForm.code,
                  })
                  .then((res) => {
                    if (res.data.Code == 200) {
                      this.loading = true;
                      // 拿到产品详细信息
                      const productStep =
                        res.data.Data.productStep == null
                          ? []
                          : res.data.Data.productStep;
                      // 拿到ssotoken
                      const _token = res.data.Data.SsoToken;
                      // const pageArr = res.data.Data.Domain;
                      // 拿到Data
                      var _Data = res.data.Data;
                      // 页面数组添加
                      // pageArr.push(process.env.VUE_APP_PAY_PC);
                      // pageArr.push(process.env.VUE_APP_PAY_H5);
                      // // 循环网站列表添加手机号
                      // pageArr.forEach((el) => {
                      //   this.pagesArrs.push(
                      //     (el +=
                      //       "#/?tel=" +
                      //       this.ruleForm.tel +
                      //       "&Data=" +
                      //       JSON.stringify(_Data) +
                      //       "&source=1")
                      //   );
                      // });
                      // // 计时器查看是否加载成功
                      // let stepPagesNum = setInterval(() => {
                      //   if (this.pageNum == this.pagesArrs.length) {
                      //     // 清除计时器
                      //     clearInterval(stepPagesNum);
                      //     this.pagesArrs = [];
                      //     this.pageNum = 0;
                      // 步骤数组
                      const StepArr = [];
                      productStep.forEach((el) => {
                        StepArr.push(el.StepNum);
                      });
                      // 判断步骤数组是否含有5
                      if (StepArr.includes(5)) {
                        this.$axios
                          .post("/apivip/Oauth2/AccessToken", {
                            Ticket: _token,
                          })
                          .then((res) => {
                            let d = res.data.Data;
                            if (res.data.Code == 200) {
                              // pageArr.forEach((el) => {
                              //   this.pagesArrs.push(
                              //     (el +=
                              //       "#/?token=" +
                              //       d.tokenMapping[0].token +
                              //       "&source=1")
                              //   );
                              // });
                              // let tokenPageStep = setInterval(() => {
                              //   if (this.pageNum == this.pagesArrs.length) {
                              //     clearInterval(tokenPageStep);
                              //     this.pagesArrs = [];
                              //     this.num = 0;
                              // 弹框关闭
                              this.dialogVisible = false;
                              Bus.$emit("isLoginFun", true);
                              // 存储手机
                              sessionStorage.setItem(
                                "Phone",
                                this.ruleForm.tel
                              );
                              localStorage.setItem("Phone", this.ruleForm.tel);
                              setCookie("Phone", this.ruleForm.tel, 28800),
                                // 存储Data
                                sessionStorage.setItem(
                                  "Data",
                                  JSON.stringify(_Data)
                                );
                              setCookie("Data", JSON.stringify(_Data), 28800),
                                localStorage.setItem(
                                  "Data",
                                  JSON.stringify(_Data)
                                );
                              // 右上角手机号
                              this.phonenumber = this.ruleForm.tel;
                              this.isShou = false;
                              this.userShou = true;
                              //   }
                              // }, 350);
                            } else {
                              Notify({
                                type: "danger",
                                message: res.data.Message,
                              });
                            }
                          });
                      } else {
                        // 弹框关闭
                        this.dialogVisible = false;
                        Bus.$emit("isLoginFun", true);
                        this.loading = false;
                        // 存储手机
                        sessionStorage.setItem("Phone", this.ruleForm.tel);
                        setCookie("Phone", this.ruleForm.tel, 28800),
                          // 存储Data
                          sessionStorage.setItem("Data", JSON.stringify(_Data));
                        setCookie("Data", JSON.stringify(_Data), 28800),
                          // 右上角手机号
                          (this.phonenumber = this.ruleForm.tel);
                        this.isShou = false;
                        this.userShou = true;
                      }
                      //   }
                      // }, 350);
                    } else {
                      Notify({ type: "danger", message: res.data.Message });
                      this.ruleForm.tel = "";
                      this.ruleForm.code = "";
                    }
                  });
              } else {
                Notify({
                  type: "danger",
                  message: res.data.Message,
                });
                this.dialogVisible = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    // 登录短信验证
    getCode() {
      // 正则校验手机号是否合法
      if (this.ruleForm.tel) {
        // 手机号正确执行
        this.disabled = true;
        this.$axios
          .post("/smsapi/Message/SendSmsCode", {
            Phone: this.ruleForm.tel,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              Notify({ type: "success", message: "验证码已发送请注意查收!" });
              // 倒计时开始
              let num = 60;
              let timeStep = setInterval(() => {
                num--;
                if (num > 0) {
                  this.codeInfo = "请在" + num + "s后重试";
                } else {
                  clearInterval(timeStep);
                  this.codeInfo = "获取验证码";
                  this.disabled = false;
                }
              }, 1000);
            } else {
              Notify({ type: "danger", message: res.data.Message });
              this.disable = false;
            }
          })
          .catch(() => {
            this.disable = false;
          });
      } else {
        Notify({ type: "warning", message: "请输入正确手机号" });
      }
    },
    // 注册短信验证
    getCodeZhuCe() {
      // 正则校验手机号是否合法
      if (this.ruleForm.tel) {
        // 手机号正确执行
        this.disabled = true;
        this.$axios
          .post("/smsapi/Message/SendSmsCode", {
            Phone: this.ruleForm.tel,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              Notify({ type: "success", message: "验证码已发送请注意查收!" });
              // 倒计时开始
              let num = 60;
              let timeStep = setInterval(() => {
                num--;
                if (num > 0) {
                  this.codeInfo = "请在" + num + "s后重试";
                } else {
                  clearInterval(timeStep);
                  this.codeInfo = "获取验证码";
                  this.disabled = false;
                }
              }, 1000);
            } else {
              Notify({ type: "danger", message: res.data.Message });
              this.disable = false;
            }
          })
          .catch(() => {
            this.disable = false;
          });
      } else {
        Notify({ type: "warning", message: "请输入正确手机号" });
      }
    },
    getList() {
      this.$axios
        .post("/trip/TokenPass/GetMenuTree", {
          Source: "238",
          IsView: 1,
        })
        .then((res) => {
          this.menu = JSON.parse(res.data.Data);
          // 获取appid
          this.getAppid();
        });
    },
    dianji() {
      this.dialogVisible = false;
      Bus.$emit("isLoginFun", true);
      this.$router.push("/");
    },
    GetQueryJson2(keyval) {
      let url = keyval; // 获取当前浏览器的URL
      let param = []; // 存储最终JSON结果对象
      url.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        param[v] = decodeURIComponent(k); //解析字符为中文
        return k + "=" + v;
      });
      return param;
    },
    shenqingData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 419,
        })
        .then((res) => {
          if (res.data.Data.list != []) {
            this.shenqingList = res.data.Data.list[0];
          } else {
            this.shenqingList = [];
          }
        });
    },
    // 通信传值
    getIndex(items) {
      this.$axios
        .post("/trip/InfoSources/AddWebsiteView", {
          IP: sessionStorage.getItem("currentIp")
            ? sessionStorage.getItem("currentIp")
            : "0.0.0.0",
          MenuName: items.label,
          Origin: 239,
        })
        .then((res) => {
          if (items.label == "申请报名") {
            if (this.shenqingList == null || this.shenqingList == []) {
              this.$message.error("当前暂无报名项目！");
              return false;
            } else {
              var _item = this.shenqingList;
              let setKey = this.GetQueryJson2(_item.Extend2);
              //从sessionStorage里面获取Data
              let sessionStorageData =
                JSON.parse(sessionStorage.getItem("Data")) ||
                JSON.parse(getCookie("Data")) ||
                [];
              //获取CustomerId
              let sessionStorageCustomerId = sessionStorageData.CustomerId;
              let _token = sessionStorageData.SsoToken;
              // 判断是否登录
              if (sessionStorageCustomerId) {
                // 登录成功是否选择过产品
                if (sessionStorageData.productStep.length > 0) {
                  // 筛选产品数组
                  const newArr = [];
                  sessionStorageData.productStep.forEach((el) => {
                    newArr.push(el.ProductId);
                  });
                  const _index = newArr.indexOf(Number(setKey.ProductId));
                  // 检查点击项目的ID是否包含在后台传输的字段里面
                  if (newArr.indexOf(Number(setKey.ProductId)) > -1) {
                    // 包含并且步骤走到5直接去学生家长平台
                    if (
                      sessionStorageData.productStep[_index].StepNum == 5 ||
                      sessionStorageData.productStep[_index].StepNum == 4
                    ) {
                      // 步骤为5的时候执行
                      // window.location.href = process.env.VUE_APP_VIP;
                      Notify({
                        type: "warning",
                        message: "您已购买过此订单，请勿重新购买！",
                      });
                    } else {
                      // 包含并且步骤不到5
                      window.location.href =
                        _item.Extend2 +
                        "&CustomerId=" +
                        sessionStorageCustomerId +
                        "&StepNum=" +
                        sessionStorageData.productStep[_index].StepNum +
                        "&PublicClueId=" +
                        this.publicClueId +
                        "&StaffContact=" +
                        this.staff;
                    }
                  } else {
                    // 不包含在后台返回,直接去填写信息面去登录
                    window.location.href =
                      _item.Extend2 +
                      "&CustomerId=" +
                      sessionStorageCustomerId +
                      "&StepNum=2" +
                      "&PublicClueId=" +
                      this.publicClueId +
                      "&StaffContact=" +
                      this.staff;
                  }
                } else {
                  // 没有选择产品但是登录了直接跳转到点击的产品表单填写
                  window.location.href =
                    _item.Extend2 +
                    "&CustomerId=" +
                    sessionStorageCustomerId +
                    "&StepNum=2" +
                    "&PublicClueId=" +
                    this.publicClueId +
                    "&StaffContact=" +
                    this.staff;
                }
              } else {
                // 没有在网站登录直接跳去流程登录
                window.location.href =
                  _item.Extend2 +
                  "&StepNum=2" +
                  "&PublicClueId=" +
                  this.publicClueId +
                  "&StaffContact=" +
                  this.staff;
              }
            }
          } else {
            if (items.data.Path.indexOf("http") == -1) {
              this.handleClose();
              // this.$router.push(items.data.Path);
              // window.location.href = items.data.Path;
              this.$router.push({
                name: items.data.Path,
                params: {
                  id: 1,
                  html: "html",
                },
              });
            } else {
              setTimeout(function () {
                // window.open(items.data.Path);
                this.$router.push({
                  name: items.data.Path,
                  params: {
                    id: 1,
                    html: "html",
                  },
                });
              }, 100);
            }
          }
          $(".collapse").toggleClass("in");
        });
    },
    // 用户协议弹框
    protocol() {
      // this.$props.UserAgreement.getPenterData();
      this.isbool = true;
    }, // 用户隐私协议弹框
    protocolEr() {
      this.isboolEr = true;
    },
    closeDialog() {
      this.isbool = false;
    },
    closeDialogEr() {
      this.isboolEr = false;
    },
    //导航点击事件
    NavClickItem(item) {
      this.$router.push("/" + item.data.Path + ".html");
      this.dialogVisible = false;
      Bus.$emit("isLoginFun", true);
    },
  },
};
</script>
<style lang="scss" scope>
.header {
  .navbar {
    margin: 0;
    padding: 0;
  }
  .header_top {
    height: 44px;
    background: #f48729;
    background-color: #f48729;
    color: white;
    display: flex;
    padding-top: 25px;
    padding: 0px 40px;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      text-align: center;
      align-items: center;
      img {
        width: 21px;
        height: 22px;
        margin-right: 20px;
      }
      p {
        letter-spacing: 1px;
       
        font-weight: 500;
        font-size: 18px;
      }
      a {
        font-size: 18px;
       
        font-weight: 500;
        color: #fff;
        text-decoration: none;
        letter-spacing: 4px;
        img {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  .head_tab {
    width: 100%;
    height: auto;
    // background: pink;
    position: relative;
    .head_tab_top {
      width: 100%;
      height: 90px;
      padding: 10px 40px;
      border-bottom: 1px solid #f2f2f2;
      box-sizing: border-box;
      line-height: 70px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
      img {
        width: 212px;
        // height: 47;
        object-fit: cover;
        image-rendering: -moz-crisp-edges; /* Firefox */
        image-rendering: -o-crisp-edges; /* Opera */
        image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
      }
      .dengGe {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        align-items: center;
        .dengl {
          // letter-spacing: 2px;
          // float: right;
          // font-size: 26px;
          // color: #333333;
          letter-spacing: 2px;
          float: right;
          font-size: 26px;
          line-height: 26px;
          color: #333333;
          margin-top: 8px;
        }
      }
      .user {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        align-items: center;
        .touxiang {
          height: 40px;
          width: 40px;
        }
        .shouji {
          font-size: 12px;
          color: #333333;
          letter-spacing: 1px;
          margin-left: 5px;
        }
        a {
          font-size: 12px;
          margin-left: 5px;
        }
      }
      .dow {
        // margin-top: 5px;
        // i {
        //   color: #333;
        // }
        cursor: pointer;
        display: flex;
        align-items: center;
        img {
          width: 42px;
          height: 32px;
        }
      }
    }

    .head-tab-main {
      width: 100%;
      position: absolute;
      top: 10px;
      left: 0;
      margin-top: 80px;
    }
    #collapseExample {
      background: #c0c0c0;
      .lableli {
        height: 60px;
        background: #f48729;
        border-bottom: 1px solid #ffffff;
        display: flex;
        align-items: center;
        p {
          padding-left: 40px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 60px;
        }
        img {
          width: 12px;
          height: 24px;
          margin-left: auto;
          margin-right: 42px;
        }
      }
      .lableli:last-child {
        border-bottom: none;
      }
      .van-cell {
        i {
          color: white;
        }
      }
      .van-hairline--top-bottom {
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
        .collapseExample_item {
          .van-collapse-item__title {
            background: #f48729;
            color: #ffffff;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 26px;
           
            padding: 20px 40px;
          }
          .van-collapse-item__wrapper {
            .van-collapse-item__content {
              background: #ffffff;
              padding: 0;
              .collapseExample_list {
                display: flex;
                position: relative;
                .xiegan {
                  position: absolute;
                  right: 40px;
                  top: 20px;
                  width: 24px;
                  z-index: 9;
                  height: 4px;
                  background: #f7901e;
                }
                .collapseExample_cell {
                  position: relative;
                  background: #fff;
                  padding: 15px 50px;
                  div {
                    span {
                      color: #999999;
                      font-size: 24px;
                    
                      font-weight: Regular;
                    }
                  }
                }
                .collapseExample_cell.active {
                  span {
                    color: #fff;
                  }
                }
              }
            }
          }
        }
      }
      [class*="van-hairline"]::after {
        // border: 1px none solid #c0c0c0;
        border: none;
      }
      .van-cell:not(:last-child)::after {
        border-bottom: none;
      }
      a:hover,
      a:focus {
        span {
          color: white !important;
        }
        text-decoration: none;
      }
    }
  }
  //登录样式
  .loginRegistration {
    margin-top: 168px;
    background: #f5f5f5;
    padding-top: 30px;
    .loginRegistration_form {
      .prompt {
        width: 50%;
        height: 78px;
        background: #fff;
        color: #666;
        text-align: center;
        line-height: 95px;
        font-size: 32px;
      }
      .enter {
        background: #fff;
        padding-top: 80px;
        padding-bottom: 60px;
        .tip {
          // width: 576px;
          width: 80%;
          margin: 0 auto;
          p {
            font-size: 26px;
            color: #666;
          }
        }
        .getTel,
        .getCode,
        .loginBtnbox {
          width: 80%;
          margin: 0 auto;
          margin-top: 50px;
        }
        .getTel {
          .el-form-item__content {
            width: 100%;
            input {
              width: 100%;
              height: 90px;
              font-size: 26px;
            }
          }
        }
        .getCode {
          .el-form-item__content {
            width: 100%;
            display: flex;
            input {
              width: 95%;
              height: 90px;
              font-size: 26px;
            }
            .getCode_btn {
              width: 190px;
              font-size: 12px;
              padding: 10px;
            }
          }
        }
        .loginBtnbox {
          margin-top: 30px;
          .el-form-item__content {
            .terms {
              display: flex;
              margin-bottom: 15px;
              .el-checkbox {
                margin-right: 11px;
              }
              .xy {
                font-size: 22px;
              }
            }
            .loginBtn {
              background: #f48729;
              width: 100%;
              border: 0;
            }
          }
        }
      }
    }
  }

  // .van-icon {
  //   color: #fff !important;
  // }
}
</style>
